import React from 'react';
import PromotionItemWrapper from './PromotionItem.styles';

const PromotionItem = ({ path, img, name, description }) => {
  return (
    <PromotionItemWrapper>
      <a target="_blank" rel="noopener noreferrer" href={path}>
        <div>
          <div className="promotion-image">
            <img src={img} alt={name} width="100%" />
          </div>
          <p className="promotion-name">{name}</p>
          <p className="promotion-description">{description}</p>
        </div>
      </a>
    </PromotionItemWrapper>
  );
};

export default PromotionItem;
